import { AdminPage } from "../_shared"; export default function Page(){return <AdminPage title="Email Logs" />;}
